<template>
  <div class="empty-content">
    <img class="empty-content-img" src="@/assets/images/empty-content/img-empty.svg" alt="empty">
    <div class="empty-content-text" v-html="emptyMessage">
      <!-- {{ $t('COMMON.EMPTY_CONTENT_TEXT') }} -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'CommonEmptyContent',
  components: {},
  directives: {},
  props: {
    destProdutionKey: {
      type: String,
      default: 'VUE_APP_MUZIK_LISTEN'
    },
    localeKey: {
      type: String,
      default: 'COMMON.EMPTY_CONTENT_TEXT'
    },
    linkId: {
      type: String,
      default: Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)
      // default: 'default-cmc-link-id'
    }
  },
  data() {
    return {}
  },
  computed: {
    emptyMessage() {
      const listenProductName = 'MUZIK ' + process.env[this.destProdutionKey].toUpperCase()
      const localedMsg = this.$t(this.localeKey, { listen: listenProductName })
      return localedMsg.replace(listenProductName,
        `<a id="${this.linkId}" class="keyword pointer" >${listenProductName}</a>`)
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.bindingEvent()
  },
  updated() {
    this.bindingEvent()
  },
  methods: {
    bindingEvent() {
      const element = document.querySelector(`#${this.linkId}`)
      if (element) {
        element.addEventListener('click', this.goToDestination)
      }
    },
    goToDestination() {
      const localePath = this.$i18n.localePath()
      if (process.env[this.destProdutionKey].toUpperCase() === this.$production.toUpperCase()) {
        this.$router.push(localePath)
      } else {
        const subDomain = process.env[this.destProdutionKey]
        const mainDomain = process.env.VUE_APP_MUZIK_DOMAIN
        const destURL = `https://${subDomain}.${mainDomain}/${localePath}`
        window.location.href = destURL
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.empty-content {
  display: block;
  width: 100%;
  padding: 120px 0;
  text-align: center;
  &-img {
    // max-width: 270px;
  }
  &-text {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.95;
    color: $grey-50;
    margin: 20px 0;
  }
}
@media only screen and (min-width: 1440px) {}
@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {}
@media only screen and (min-width: 768px) and (max-width: 1023.98px) {}
@media only screen and (max-width: 767.98px) {}
@media only screen and (max-width: 423.98px) {
  .empty-content {
    &-img {
      width: 100%;
    }
  }
}
</style>
